import {
    ChangeDetectionStrategy,
    Component,
    effect,
    inject,
    input,
    InputSignal,
    signal,
    WritableSignal
} from "@angular/core";
import {GroupOrderModel} from "../group-order.model";
import {OrderModel} from '../../order/order.model';
import {NgClass} from '@angular/common';
import {IconComponent} from '../../ui-elements/icon/icon.component';

@Component({
    selector: "woa-group-order-summary-icon",
    templateUrl: "./group-order-summary-icon.component.html",
    styleUrl: "./group-order-summary-icon.component.scss",
    imports: [
        IconComponent,
        NgClass
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GroupOrderSummaryIconComponent {
    public orderModel: OrderModel = inject(OrderModel);
    public groupOrderModel: GroupOrderModel = inject(GroupOrderModel);

    public readonly showWithoutGroupOrder: InputSignal<boolean> = input<boolean>(false);
    public readonly countColorPair: InputSignal<string> = input<string>("panel");

    highlighted: WritableSignal<boolean> = signal<boolean>(false);

    constructor() {
        if (this.orderModel.totalTransfers() || this.groupOrderModel.hasGroupOrder()) {
            this.highlight();
        }

        effect(() => {
            if (this.orderModel.totalTransfers()) {
                this.highlight();
            }
        });

        effect(() => {
            if (this.groupOrderModel.hasGroupOrder()) {
                this.highlight();
            }
        });
    }

    highlight(): void {
        this.highlighted.set(true);
        setTimeout(() => {
            this.highlighted.set(false);
        }, 3000);
    }
}
